const decimalPattern = /^\d+(\.\d{2})$/;

export function assertMoney(value: string): string {
  if (!decimalPattern.test(value)) throw new Error(`Invalid money value: ${value}`);
  return value;
}

export function moneyToCents(value: string): bigint {
  assertMoney(value);
  const [major, minor] = value.split(".");
  return BigInt(major) * 100n + BigInt(minor);
}

export function centsToMoney(value: bigint): string {
  const negative = value < 0n;
  const absolute = negative ? -value : value;
  const major = absolute / 100n;
  const minor = absolute % 100n;
  return `${negative ? "-" : ""}${major}.${minor.toString().padStart(2, "0")}`;
}

export function addMoney(values: string[]): string {
  return centsToMoney(values.reduce((total, value) => total + moneyToCents(value), 0n));
}

export function formatKes(value: string): string {
  assertMoney(value);
  return `KES ${Number(value).toLocaleString("en-KE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}

export function normalizeMoneyInput(value: unknown): string | null {
  if (typeof value === "number" && Number.isInteger(value)) return `${value}.00`;
  if (typeof value !== "string") return null;
  const trimmed = value.trim().replace(/,/g, "");
  if (/^\d+$/.test(trimmed)) return `${trimmed}.00`;
  if (/^\d+\.\d$/.test(trimmed)) return `${trimmed}0`;
  if (decimalPattern.test(trimmed)) return trimmed;
  return null;
}
